import { debounce, disableSticky } from "../utility/UtilityFunctions";

export default class FilterableAccordion {
    constructor(el) {
        this.filter = el.querySelector("#sections-filter");
        this.accordion = el.querySelectorAll(".c-filterable-accordion-section");
        this.checkboxes = el.querySelectorAll("[type=checkbox]");
        this.questionsContainer = el.querySelector(".c-filterable-accordion-questions");
        this.titleElement = el.querySelector("h2[data-title]");
        this.formElement = el.querySelector('.o-form');

        // optional scrollTo variables
        this.pageHeader = document.querySelector(".c-page-header");
        this.scrollPadding = 100;  // The amount of scroll padding you want to offset, e.g., for a fixed header
        this.scrollDuration = 500;

        // this.isMobileLayout = window.innerWidth < 1240;

        this.addEventListeners();
    }

    addEventListeners() {
        this.filter.addEventListener("change", (event) => {
            this.filterValues(event.target);
        });

        window.addEventListener('resize', debounce(() => {
            if (this.formElement) {
                disableSticky(this.formElement, parseFloat(window.getComputedStyle(this.formElement).top));
            }

            // this.isMobileLayout = window.innerWidth < 1240;
        }, 250));
    }

    filterValues(target) {
        if (document.startViewTransition) {
            document.startViewTransition(() => this.updateFilter(target));
        } else {
            this.updateFilter(target);
        }
    }

    updateFilter(target) {
        let value = target.value,
            label = target.parentElement;

        // Set the height to the combined height of visible children during the transition phase
        // if (this.isMobileLayout) {
            this.setContainerHeightDuringTransition();
        // }

        // update label active states
        this.checkboxes.forEach( element => {
            element.parentElement.classList.remove('is-active')
        })
        label.classList.add('is-active')

        // Hide all sections initially
        this.accordion.forEach((item, index) => {
            // item.style.viewTransitionName = `accordion-section-${index}`; // Ensure unique transition name
            item.classList.remove("show");
            item.classList.remove("initial-item");
            item.classList.add("hide");

            // optional style additions
            item.style.opacity = "0";
            item.style.transform = "translateY(20px)";
            item.style.display = "none"; // Hide the item
        });

        let formattedValue = this.formatValue(value);

        if (this.titleElement) {
            this.titleElement.dataset.title = `Showing ${formattedValue}`;
            const span = this.titleElement.querySelector("span");
            if (span) {
                span.textContent = `Showing ${formattedValue}`;
            }
        }

        // Show only the selected sections and hold the height during the transition
        let removeItemMarginTop = false;
        this.accordion.forEach((item) => {
            if (value === "*" || value === item.dataset.filter) {
                setTimeout(() => {
                    item.style.display = "block";

                    if (!removeItemMarginTop) {
                        removeItemMarginTop = true;
                        item.classList.add('initial-item')
                    }

                    setTimeout(() => {
                        item.classList.add("show");
                        item.classList.remove("hide");

                        // optional style additions
                        item.style.opacity = "1";
                        item.style.transform = "translateY(0)";
                    }, 150); // Add a small delay for smoother transition
                }, 100); // Initial delay for the animation
            }
        });

        // Scroll to the top of the questions container
        // if (!this.isMobileLayout) {
            this.scrollToTop();
        // }

        this.clearUncheckedFilters(value);

        // After transition, recalculate and remove the inline height style
        setTimeout(() => {
            // if (this.isMobileLayout) {
                this.recalculateHeight();
            // }
        }, 300);  // Allow time for the transition to finish before recalculating height
    }

    setContainerHeightDuringTransition() {
        // Calculate the combined height of visible accordion sections
        let visibleHeight = 0;
        this.accordion.forEach(item => {
            if (!item.classList.contains("hide")) {
                visibleHeight += item.offsetHeight;
            }
        });

        // Set the height of the questions container to hold during the transition
        this.questionsContainer.style.height = `${visibleHeight}px`;
    }

    recalculateHeight() {
        // Once the transition is complete, recalculate the height based on the visible content
        let visibleHeight = 0;
        this.accordion.forEach(item => {
            if (item.classList.contains("show")) {
                visibleHeight += item.offsetHeight;
            }
        });

        // Apply the new height to the questions container
        this.questionsContainer.style.height = `${visibleHeight}px`;

        // Remove the inline height style after the transition
        setTimeout(() => {
            this.questionsContainer.style.removeProperty('height');
        }, 500); // Allow time for the transition to finish before removing the height
    }

    clearUncheckedFilters(value) {
        this.checkboxes.forEach(filter => {
            if (value === "*" && filter.value !== "*") {
                filter.checked = false; // Uncheck all other checkboxes
            } else if (value !== "*" && filter.value !== value && filter.checked) {
                filter.checked = false;
            }
        });
    }

    formatValue(value) {
        if (value === '*') return 'All';
        const formatted = value.replace(/-/g, ' ');
        return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
    }

    scrollToTop() {
        const headerHeight = this.pageHeader ? this.pageHeader.offsetHeight : 0;
        const filterHeight = this.questionsContainer.previousElementSibling ? this.questionsContainer.previousElementSibling.offsetHeight : 0;
        const totalOffset = this.scrollPadding + headerHeight + filterHeight;

        const containerPosition = this.questionsContainer.getBoundingClientRect().top + window.scrollY;
        const scrollToPosition = containerPosition - totalOffset;
        const startPosition = window.scrollY;
        const distance = scrollToPosition - startPosition;

        const scrollStep = (timestamp) => {
            if (!this.startTime) this.startTime = timestamp;

            const elapsed = timestamp - this.startTime;
            const progress = Math.min(elapsed / this.scrollDuration, 1);

            window.scrollTo({
                top: startPosition + distance * progress,
                behavior: 'auto'
            });

            if (elapsed < this.scrollDuration) {
                window.requestAnimationFrame(scrollStep);
            }
        };

        window.requestAnimationFrame(scrollStep);
    }
}